function Hero2() {
  return (
    <section className="bg-hijau flex flex-col lg:flex-row mt-12 items-center">
      <div className="flex flex-col gap-[54px] lg:pl-10 px-5 lg:px-0 mt-16 lg:mt-0">
        <h1 className="lg:text-[54px] text-3xl font-semibold text-white leading-tight tracking-[-0.7px]">
          Mulailah perjalananmu dengan Al-Quran
        </h1>
        <p className="text-sm lg:text-base font-semibold text-white leading-[22px] tracking-[-0.7px]">
          Membaca, memahami, dan mengamalkan Al-Quran adalah langkah awal untuk
          meraih kehidupan yang penuh berkah Dengan Al-Quran, temukan petunjuk
          yang akan membimbing setiap langkahmu, menghadirkan kedamaian,
          kebijaksanaan, dan kekuatan dalam menjalani setiap aspek kehidupan.
        </p>
        <div className="flex gap-5">
          <h1
            href="#"
            className="bg-hijau2 flex items-center text-base lg:text-lg font-semibold text-white tracking-[-0.7px] px-8 lg:px-[51px] py-4 rounded-xl"
          >
            Baca Quran
          </h1>
          <h1
            href="#"
            className="border-2 border-white flex items-center text-lg font-semibold text-white tracking-[-0.7px] px-8 lg:px-[51px] py-4 rounded-xl"
          >
            Jadwal Sholat
          </h1>
        </div>
      </div>
      <img src="./hero2.png" alt="" className="w-[597px]" />
    </section>
  );
}

export default Hero2;
